import { errorMessages } from '@/utils/constants';
import React, { useEffect, useState } from 'react'
import InputField from "@/components/common/CommonInputComponent";

function EditName(props) {
  const { styles,
    userDetails,
    successMsg,
    setSuccessMessage,
    firstNameChanged,
    lastNameChanged,
    submitFormEdit,
    loading,
    updatedSuccess
  } = props;
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [firstNameError, setFirstNameError] = useState('');
  const [lastNameError, setLastNameError] = useState('');

  useEffect(() => {
    setFirstName(userDetails.firstName);
    setLastName(userDetails.lastName);
  }, []);

  const handleBlurOut = (target, placeholderText) => {
    if (target) {
      target.placeholder = placeholderText;
    }
  };

  const handleFirstName = (event) => {
    let firstName =
      event.target.firstName && event.target.firstName.value
        ? event.target.firstName.value
        : event.target.value;

    if (firstName) {
      setFirstNameError("");
    } else {
      setFirstNameError(errorMessages.authentication.emptyFirstName);
    }
  }
  const handleLastName = (event) => {
    let lastName =
      event.target.lastName && event.target.lastName.value
        ? event.target.lastName.value
        : event.target.value;

    if (lastName) {
      setLastNameError("");
    } else {
      setLastNameError(errorMessages.authentication.emptyLastName);
    }
  }
  const handleNameSubmit = () => {
    if (firstName && lastName) {
      submitFormEdit({ firstName: firstName, lastName: lastName });
    }
    else {
      if (!firstName) {
        setFirstNameError(errorMessages.authentication.emptyFirstName)
      }
      if (!lastName) {
        setLastNameError(errorMessages.authentication.emptyLastName)
      }
    }
  }
  return (
    <>
      <div className={`${styles.account_card} edit_details wrapper`}>
        <div className="item-wrapper mb-30">
        <InputField
            type="text"
            id="firstName"
            name='firstName'
            label="First name*"
            placeholder=" "
            autoComplete='first-name'
            ariaLabel='your-first-name'
            className="normal-md small-xs normal-sm"
            errorMessage={firstNameError}
            onChange={e => {
              setFirstName(e.currentTarget.value);
              setSuccessMessage("");
            }}
            onBlur={(e) => {
              handleFirstName(e);
              // handleBlurOut(e.currentTarget, "Your first name");
            }}
            isEditTab={true}
            successMsg={successMsg}
            updatedSuccess={updatedSuccess}
            nameChanged={firstNameChanged}
            value={firstName}
          />
        </div>
        <br />
        <div className="item-wrapper mb-30">
        <InputField
            type="text"
            id="lastName"
            name='lastName'
            label="Last name*"
            placeholder=" "
            autoComplete='family-name'
            ariaLabel='your-last-name'
            className="normal-md small-xs normal-sm"
            errorMessage={lastNameError}
            onChange={e => {
              setLastName(e.currentTarget.value);
              setSuccessMessage("");
            }}
            onBlur={(e) => {
              handleLastName(e);
              // handleBlurOut(e.currentTarget, "Your first name");
            }}
            isEditTab={true}
            successMsg={successMsg}
            updatedSuccess={updatedSuccess}
            nameChanged={lastNameChanged}
            value={lastName}
          />
        </div>
        <button className={`btn-primary w-full btn_loading ${loading ? "loading" : ""}`} onClick={handleNameSubmit}><span>Save</span></button>
      </div>
    </>
  )
}

export default EditName